function splider() {
    const compatiblitySlider = document.querySelector('.compatibility-list');
    if (compatiblitySlider) {
        const compatibleSlide = new Splide(compatiblitySlider, {
            perPage: 4,
            perMove: 1,
            gap: 16,
            pagination: false,
            arrows: false,
            autoplay: true,
            breakpoints: {
            940: {
                type: 'loop',
                perPage: 3,
                rewind : true,
                arrows: true,
            },
            820: {
                perPage: 2,
            }, 
            767: {
                perPage: 1,
            },
            }
        });
        compatibleSlide.mount();
    }

    const incompatiblitySlider = document.querySelector('.incompatibility-list');
    if (incompatiblitySlider) {
        const incompatibleSlide = new Splide(incompatiblitySlider, {
            perPage: 4,
            perMove: 1,
            gap: 16,
            pagination: false,
            arrows: false,
            autoplay: true,
            breakpoints: { 
            940: {
                type: 'loop',
                perPage: 3,
                rewind : true,
                arrows: true,
            }, 
            820: {
                perPage: 2,
            }, 
            767: {
                perPage: 1,
            },
            }
        });
        incompatibleSlide.mount();
    }
}
splider();